import React, { useContext, Fragment } from 'react';
import { Link } from '@reach/router';
import { AuthContext } from '../AuthContext';

export const Logout = () => {
	const { removeAuth } = useContext(AuthContext);
	return (
		<Fragment>
			{/* <ErrorAlert errorMessage='404' /> */}
			<div class="abs-center wd-xl">
				<div class="text-center mb-4">
					<div class="text-lg mb-3">Log out</div>
					<p class="lead m-0">Are you sure do you want to log out?</p>
					{/* <p>The page you are looking for does not exists.</p> */}
				</div>
				<div class="text-center mb-4">
					<span>
						<button class="btn btn-primary" type="button" onClick={removeAuth}><em class="fa icon-logout mr-2"></em> LOGOUT</button>
					</span>
				</div>
				<ul class="list-inline text-center text-sm mb-4">
					<li class="list-inline-item"><Link class="text-muted" to="/">Back to Home</Link></li>
				</ul>
				<div class="p-3 text-center"><span class="mr-2">&copy;</span><span>2022</span><span class="mr-2">-</span><span>ALEX</span><br/></div>
			</div>
		</Fragment>
	);
};